import * as React from 'react'

import LinkComponent from 'src/components/UI/LinkComponent/LinkComponent'

import styles from './Breadcrumbs.module.scss'
import { ArrowRightIcon } from '../UI/Icon/Icon'

type Props = {
  items: object[]
}

const BreadCrumbs = ({ items }: Props) => (
  <div className={styles.breadcrumbs}>
    {items &&
      items.map((item: any, index: number) => (
        <React.Fragment key={index}>
          {item.link ? (
            <span>
              <LinkComponent to={item.link}>{item.name}</LinkComponent>
            </span>
          ) : (
            <span>{item.name}</span>
          )}
          {index !== items.length - 1 && (
            <div className={styles.separator}>
              <ArrowRightIcon width={7} height={5} color="rgba(0,0,0,0.1)" />
            </div>
          )}
        </React.Fragment>
      ))}
  </div>
)

export default BreadCrumbs
